import Vue from 'vue'

import VueI18n from 'vue-i18n'
import Vuelidate from 'vuelidate'
import PortalVue from 'portal-vue'
import MedicalOfficePlugin from '@/plugins/MedicalOffice'

import BackendPlugin from '@/plugins/Backend'
import BrowserPlugin from '@/plugins/Browser'
import ConfirmationPlugin from '@/plugins/Confirmation'
import EventBus from '@/plugins/EventBus'
import LoadingPlugin from '@/plugins/Loading'
import AbConfigPlugin from '@/plugins/AbConfig'
import NotificationPlugin from '@/plugins/Notifications'
import SessionPlugin from '@/plugins/Session'
import TrackerPlugin from '@/plugins/Tracker'
import Cobrowse from '@/plugins/Cobrowse'

import registerDirectives from '@/setup/registerDirectives'
import { registerFormComponents, registerIconComponent, registerTypographyComponent } from '@/setup/registerComponents'

import config from '@/config'
import { EVENT_ERROR, EVENT_LANGUAGE_LOADED } from '@/config/events'
import npm from '@/../package'
import { PageHelper } from '@/helpers/Page'

import '@/assets/css/variables.css'

const isBrowser = window?.matchMedia
let vueInstance

if (isBrowser) {
  if (!window.Vue) {
    window.Vue = createInstance()
  }
  vueInstance = window.Vue
} else {
  vueInstance = createInstance()
}

/**
 * @returns {Vue | VueConstructor}
 */
function createInstance() {
  Vue.config.productionTip = false
  Vue.prototype.$version = npm.version

  // Register main plugins
  Vue.use(VueI18n)
  Vue.use(EventBus)
  Vue.use(NotificationPlugin)

  let language = document.documentElement.getAttribute('lang')
  switch (language.toLowerCase()) {
    case 'de':
    case 'en':
    case 'fr':
    case 'it':
      break

    default:
      language = 'en'
      break
  }

  Vue.prototype.i18n = new VueI18n({
    silentTranslationWarn: process.env.DEPLOYED_ENV === 'production',
    locale: language,
    messages: { [language]: {} },
  })

  PageHelper.loadLanguageContentAndSetLanguage(language, Vue.prototype.i18n)
    .then(messages => {
      Vue.prototype.$EventBus.$on(EVENT_ERROR, event => {
        let content = event.error
        if (event.eval === true) {
          content = eval(`messages.${event.error}`)
        }
        return Vue.prototype.$notification.error(content)
      })
      Vue.prototype.$EventBus.$emit(EVENT_LANGUAGE_LOADED, language)
      return messages
    })
    .then(messages => PageHelper.setPageTitleAndDescription(messages.meta))

  Vue.use(SessionPlugin, config)
  Vue.use(BackendPlugin)
  Vue.use(BrowserPlugin, {
    desktopThreshold: config.desktopThreshold,
  })
  Vue.use(ConfirmationPlugin)
  Vue.use(LoadingPlugin)
  Vue.use(AbConfigPlugin)
  Vue.use(TrackerPlugin)

  registerDirectives(Vue)
  registerTypographyComponent(Vue)
  registerIconComponent(Vue)
  registerFormComponents(Vue)

  Vue.use(MedicalOfficePlugin, {
    apiKey: config.googleApiKey,
    imagePath: config.googleImagePath,
  })
  Vue.use(PortalVue)
  Vue.use(Vuelidate)
  Vue.use(Cobrowse)

  Vue.prototype.$backend.initialize(config)

  console.info(
    '%c ⚑ sani%ctas DVP',
    'font-weight:bold;color:#00765A;',
    'font-weight:bold;color:#5BAC26;',
    `v${npm.version}`
  )
  return Vue
}

export default vueInstance